import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for member groups hooks
 * Keys match backend controller method names
 */
export const memberGroupsKeys = {
  findMemberGroups: (memberUuid: string, params?: QueryParamsDto) =>
    params
      ? (["member-groups", memberUuid, "findMemberGroups", params] as const)
      : (["member-groups", memberUuid, "findMemberGroups"] as const),
} as const
